import React, { ReactNode, useState } from 'react';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';

const TeamContainer = styled('div')`
  margin: 1rem 2rem;
`;

const StyledButton = styled(Button)`
  color: #ffffff;
  margin: 0 0;
`;

interface Props {
  color: string;
  name: string;
  desc: string;
  descMore?: string | ReactNode;
}

export const Team = ({ color, name, desc, descMore }: Props): JSX.Element => {
  const [isFullView, setFullView] = useState(false);

  const handleViewToggle = () => {
    setFullView(!isFullView);
  };

  return (
    <Grid item xs={12} md={6} style={{ backgroundColor: color }}>
      <TeamContainer>
        <Typography variant="h3" component="h3" style={{ color: '#ffffff' }}>
          {name}
        </Typography>

        <Typography variant="body1" component="p" style={{ color: '#ffffff' }}>
          {desc}
        </Typography>

        {!isFullView && descMore && (
          <StyledButton variant="text" onClick={handleViewToggle}>
            Erfahre mehr...
          </StyledButton>
        )}

        {isFullView && descMore && (
          <>
            <Typography
              variant="body1"
              component="p"
              style={{ color: '#ffffff' }}
            >
              {descMore}
            </Typography>

            <StyledButton variant="text" onClick={handleViewToggle}>
              Weniger anzeigen...
            </StyledButton>
          </>
        )}
      </TeamContainer>
    </Grid>
  );
};
